<template>
  <nav aria-label="Breadcrumb">
    <ol
      class="flex items-center gap-0.5 sm:gap-1 text-sm text-gray-600 overflow-x-auto px-3 sm:px-0 py-1.5 sm:py-2 scrollbar-none"
    >
      <li
        v-for="(b, i) in breadcrumbs"
        :key="i"
        class="flex items-center shrink-0"
      >
        <Icon
          v-if="i !== 0"
          icon="mdi:chevron-right"
          class="mx-1.5 text-gray-400 shrink-0"
          aria-hidden="true"
        />

        <RouterLink
          v-if="i < breadcrumbs.length - 1"
          :to="b.to"
          class="inline-flex items-center gap-1 hover:text-mocha-mousse-800 hover:underline underline-offset-2 decoration-mocha-mousse-400 transition-colors max-w-[18ch] truncate"
        >
          <Icon
            :icon="i === 0 ? 'mdi:home-outline' : 'mdi:folder-outline'"
            class="text-gray-400 shrink-0"
          />
          <span class="truncate">{{ b.label }}</span>
        </RouterLink>

        <span
          v-else
          class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-mocha-mousse-100 text-mocha-mousse-900 font-medium max-w-[14ch] sm:max-w-[22ch]"
          aria-current="page"
        >
          <Icon
            :icon="i === 0 ? 'mdi:home-outline' : 'mdi:folder-outline'"
            class="text-gray-500 shrink-0"
          />
          <span class="truncate">{{ b.label }}</span>
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { buildTopLevelBreadcrumbs } from "@/services/breadcrumbs";
import { Icon } from "@iconify/vue";

const route = useRoute();
const breadcrumbs = computed(() => buildTopLevelBreadcrumbs(route));
</script>
